import * as Types from '../../../../../generated/types';

import { gql } from '@apollo/client';
import { ImpactGroupFieldsFragmentDoc } from './fragments.gql.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AccountsWithImpactGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AccountsWithImpactGroupsQuery = (
  { __typename?: 'Query' }
  & { accounts?: Types.Maybe<(
    { __typename?: 'AccountConnection' }
    & Pick<Types.AccountConnection, 'totalCount'>
    & { nodes: Array<Types.Maybe<(
      { __typename?: 'Account' }
      & Pick<Types.Account, 'id' | 'accountName'>
    )>> }
  )> }
);

export type AllImpactGroupsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AllImpactGroupsQuery = (
  { __typename?: 'Query' }
  & { impactGroupTemplates?: Types.Maybe<(
    { __typename?: 'ImpactGroupTemplateConnection' }
    & Pick<Types.ImpactGroupTemplateConnection, 'totalCount'>
    & { groups: Array<Types.Maybe<(
      { __typename?: 'ImpactGroupTemplate' }
      & Pick<Types.ImpactGroupTemplate, 'rowId' | 'label' | 'slug' | 'description' | 'notificationMessage' | 'severity' | 'scope' | 'active' | 'actionUrl' | 'createdBy' | 'updatedBy' | 'templateExpiresAt' | 'createdAt' | 'updatedAt'>
      & { assignmentCount: (
        { __typename?: 'ImpactGroupAssignmentConnection' }
        & Pick<Types.ImpactGroupAssignmentConnection, 'totalCount'>
      ) }
    )>> }
  )> }
);

export type ImpactGroupsByAccountQueryVariables = Types.Exact<{
  rowId: Types.Scalars['Int']['input'];
}>;


export type ImpactGroupsByAccountQuery = (
  { __typename?: 'Query' }
  & { account?: Types.Maybe<(
    { __typename?: 'Account' }
    & { impactGroupAssignments: (
      { __typename?: 'ImpactGroupAssignmentConnection' }
      & Pick<Types.ImpactGroupAssignmentConnection, 'totalCount'>
      & { nodes: Array<Types.Maybe<(
        { __typename?: 'ImpactGroupAssignment' }
        & Pick<Types.ImpactGroupAssignment, 'id' | 'accountId' | 'userId' | 'impactGroupId' | 'assignedBy' | 'assignedAt' | 'assignmentExpiresAt' | 'dismissedAt' | 'dynamicMessageContent'>
        & { impactGroup?: Types.Maybe<(
          { __typename?: 'ImpactGroupTemplate' }
          & Pick<Types.ImpactGroupTemplate, 'rowId' | 'label' | 'slug' | 'description' | 'notificationMessage' | 'severity' | 'scope' | 'active' | 'actionUrl' | 'createdBy' | 'updatedBy' | 'templateExpiresAt' | 'createdAt' | 'updatedAt'>
        )> }
      )>> }
    ) }
  )> }
);

export type ImpactGroupsByUserQueryVariables = Types.Exact<{
  rowId: Types.Scalars['Int']['input'];
}>;


export type ImpactGroupsByUserQuery = (
  { __typename?: 'Query' }
  & { user?: Types.Maybe<(
    { __typename?: 'User' }
    & Pick<Types.User, 'rowId'>
    & { accounts: (
      { __typename?: 'AccountConnection' }
      & Pick<Types.AccountConnection, 'totalCount'>
      & { nodes: Array<Types.Maybe<(
        { __typename?: 'Account' }
        & Pick<Types.Account, 'accountName' | 'id' | 'rowId'>
        & { impactGroupAssignments: (
          { __typename?: 'ImpactGroupAssignmentConnection' }
          & { nodes: Array<Types.Maybe<(
            { __typename?: 'ImpactGroupAssignment' }
            & Pick<Types.ImpactGroupAssignment, 'id' | 'accountId' | 'impactGroupId' | 'assignedAt' | 'assignmentExpiresAt' | 'dismissedAt' | 'dynamicMessageContent'>
            & { impactGroup?: Types.Maybe<(
              { __typename?: 'ImpactGroupTemplate' }
              & Pick<Types.ImpactGroupTemplate, 'rowId' | 'label' | 'slug' | 'description' | 'notificationMessage' | 'severity' | 'scope' | 'active' | 'actionUrl' | 'createdBy' | 'updatedBy' | 'templateExpiresAt' | 'createdAt' | 'updatedAt'>
            )> }
          )>> }
        ) }
      )>> }
    ) }
  )>, userAssignments?: Types.Maybe<(
    { __typename?: 'ImpactGroupAssignmentConnection' }
    & { nodes: Array<Types.Maybe<(
      { __typename?: 'ImpactGroupAssignment' }
      & Pick<Types.ImpactGroupAssignment, 'id' | 'userId' | 'impactGroupId' | 'assignedAt' | 'assignmentExpiresAt' | 'dismissedAt' | 'dynamicMessageContent'>
      & { impactGroup?: Types.Maybe<(
        { __typename?: 'ImpactGroupTemplate' }
        & Pick<Types.ImpactGroupTemplate, 'rowId' | 'label' | 'slug' | 'description' | 'notificationMessage' | 'severity' | 'scope' | 'active' | 'actionUrl' | 'createdBy' | 'updatedBy' | 'templateExpiresAt' | 'createdAt' | 'updatedAt'>
      )> }
    )>> }
  )> }
);


export const AccountsWithImpactGroupsDocument = gql`
    query accountsWithImpactGroups {
  accounts(filter: {impactGroupAssignmentsExist: true}) {
    totalCount
    nodes {
      id
      accountName
    }
  }
}
    `;

/**
 * __useAccountsWithImpactGroupsQuery__
 *
 * To run a query within a React component, call `useAccountsWithImpactGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAccountsWithImpactGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAccountsWithImpactGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAccountsWithImpactGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AccountsWithImpactGroupsQuery, AccountsWithImpactGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AccountsWithImpactGroupsQuery, AccountsWithImpactGroupsQueryVariables>(AccountsWithImpactGroupsDocument, options);
      }
export function useAccountsWithImpactGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AccountsWithImpactGroupsQuery, AccountsWithImpactGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AccountsWithImpactGroupsQuery, AccountsWithImpactGroupsQueryVariables>(AccountsWithImpactGroupsDocument, options);
        }
// @ts-ignore
export function useAccountsWithImpactGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AccountsWithImpactGroupsQuery, AccountsWithImpactGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountsWithImpactGroupsQuery, AccountsWithImpactGroupsQueryVariables>;
export function useAccountsWithImpactGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountsWithImpactGroupsQuery, AccountsWithImpactGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<AccountsWithImpactGroupsQuery | undefined, AccountsWithImpactGroupsQueryVariables>;
export function useAccountsWithImpactGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AccountsWithImpactGroupsQuery, AccountsWithImpactGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AccountsWithImpactGroupsQuery, AccountsWithImpactGroupsQueryVariables>(AccountsWithImpactGroupsDocument, options);
        }
export type AccountsWithImpactGroupsQueryHookResult = ReturnType<typeof useAccountsWithImpactGroupsQuery>;
export type AccountsWithImpactGroupsLazyQueryHookResult = ReturnType<typeof useAccountsWithImpactGroupsLazyQuery>;
export type AccountsWithImpactGroupsSuspenseQueryHookResult = ReturnType<typeof useAccountsWithImpactGroupsSuspenseQuery>;
export type AccountsWithImpactGroupsQueryResult = Apollo.QueryResult<AccountsWithImpactGroupsQuery, AccountsWithImpactGroupsQueryVariables>;
export const AllImpactGroupsDocument = gql`
    query AllImpactGroups {
  impactGroupTemplates {
    totalCount
    groups: nodes {
      ...ImpactGroupFields
      assignmentCount: impactGroupAssignments {
        totalCount
      }
    }
  }
}
    ${ImpactGroupFieldsFragmentDoc}`;

/**
 * __useAllImpactGroupsQuery__
 *
 * To run a query within a React component, call `useAllImpactGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllImpactGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllImpactGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllImpactGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AllImpactGroupsQuery, AllImpactGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllImpactGroupsQuery, AllImpactGroupsQueryVariables>(AllImpactGroupsDocument, options);
      }
export function useAllImpactGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllImpactGroupsQuery, AllImpactGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllImpactGroupsQuery, AllImpactGroupsQueryVariables>(AllImpactGroupsDocument, options);
        }
// @ts-ignore
export function useAllImpactGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllImpactGroupsQuery, AllImpactGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<AllImpactGroupsQuery, AllImpactGroupsQueryVariables>;
export function useAllImpactGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllImpactGroupsQuery, AllImpactGroupsQueryVariables>): Apollo.UseSuspenseQueryResult<AllImpactGroupsQuery | undefined, AllImpactGroupsQueryVariables>;
export function useAllImpactGroupsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllImpactGroupsQuery, AllImpactGroupsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllImpactGroupsQuery, AllImpactGroupsQueryVariables>(AllImpactGroupsDocument, options);
        }
export type AllImpactGroupsQueryHookResult = ReturnType<typeof useAllImpactGroupsQuery>;
export type AllImpactGroupsLazyQueryHookResult = ReturnType<typeof useAllImpactGroupsLazyQuery>;
export type AllImpactGroupsSuspenseQueryHookResult = ReturnType<typeof useAllImpactGroupsSuspenseQuery>;
export type AllImpactGroupsQueryResult = Apollo.QueryResult<AllImpactGroupsQuery, AllImpactGroupsQueryVariables>;
export const ImpactGroupsByAccountDocument = gql`
    query ImpactGroupsByAccount($rowId: Int!) {
  account(rowId: $rowId) {
    impactGroupAssignments {
      totalCount
      nodes {
        id
        accountId
        userId
        impactGroupId
        assignedBy
        assignedAt
        assignmentExpiresAt
        dismissedAt
        dynamicMessageContent
        impactGroup {
          ...ImpactGroupFields
        }
      }
    }
  }
}
    ${ImpactGroupFieldsFragmentDoc}`;

/**
 * __useImpactGroupsByAccountQuery__
 *
 * To run a query within a React component, call `useImpactGroupsByAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpactGroupsByAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpactGroupsByAccountQuery({
 *   variables: {
 *      rowId: // value for 'rowId'
 *   },
 * });
 */
export function useImpactGroupsByAccountQuery(baseOptions: Apollo.QueryHookOptions<ImpactGroupsByAccountQuery, ImpactGroupsByAccountQueryVariables> & ({ variables: ImpactGroupsByAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpactGroupsByAccountQuery, ImpactGroupsByAccountQueryVariables>(ImpactGroupsByAccountDocument, options);
      }
export function useImpactGroupsByAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpactGroupsByAccountQuery, ImpactGroupsByAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpactGroupsByAccountQuery, ImpactGroupsByAccountQueryVariables>(ImpactGroupsByAccountDocument, options);
        }
// @ts-ignore
export function useImpactGroupsByAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImpactGroupsByAccountQuery, ImpactGroupsByAccountQueryVariables>): Apollo.UseSuspenseQueryResult<ImpactGroupsByAccountQuery, ImpactGroupsByAccountQueryVariables>;
export function useImpactGroupsByAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImpactGroupsByAccountQuery, ImpactGroupsByAccountQueryVariables>): Apollo.UseSuspenseQueryResult<ImpactGroupsByAccountQuery | undefined, ImpactGroupsByAccountQueryVariables>;
export function useImpactGroupsByAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImpactGroupsByAccountQuery, ImpactGroupsByAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImpactGroupsByAccountQuery, ImpactGroupsByAccountQueryVariables>(ImpactGroupsByAccountDocument, options);
        }
export type ImpactGroupsByAccountQueryHookResult = ReturnType<typeof useImpactGroupsByAccountQuery>;
export type ImpactGroupsByAccountLazyQueryHookResult = ReturnType<typeof useImpactGroupsByAccountLazyQuery>;
export type ImpactGroupsByAccountSuspenseQueryHookResult = ReturnType<typeof useImpactGroupsByAccountSuspenseQuery>;
export type ImpactGroupsByAccountQueryResult = Apollo.QueryResult<ImpactGroupsByAccountQuery, ImpactGroupsByAccountQueryVariables>;
export const ImpactGroupsByUserDocument = gql`
    query ImpactGroupsByUser($rowId: Int!) {
  user(rowId: $rowId) {
    rowId
    accounts(filter: {impactGroupAssignmentsExist: true}) {
      totalCount
      nodes {
        accountName
        id
        rowId
        impactGroupAssignments(filter: {impactGroup: {scope: {equalTo: "account"}}}) {
          nodes {
            id
            accountId
            impactGroupId
            assignedAt
            assignmentExpiresAt
            dismissedAt
            dynamicMessageContent
            impactGroup {
              ...ImpactGroupFields
            }
          }
        }
      }
    }
  }
  userAssignments: impactGroupAssignments(
    filter: {user: {rowId: {equalTo: $rowId}}, impactGroup: {scope: {equalTo: "user"}}}
  ) {
    nodes {
      id
      userId
      impactGroupId
      assignedAt
      assignmentExpiresAt
      dismissedAt
      dynamicMessageContent
      impactGroup {
        ...ImpactGroupFields
      }
    }
  }
}
    ${ImpactGroupFieldsFragmentDoc}`;

/**
 * __useImpactGroupsByUserQuery__
 *
 * To run a query within a React component, call `useImpactGroupsByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useImpactGroupsByUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useImpactGroupsByUserQuery({
 *   variables: {
 *      rowId: // value for 'rowId'
 *   },
 * });
 */
export function useImpactGroupsByUserQuery(baseOptions: Apollo.QueryHookOptions<ImpactGroupsByUserQuery, ImpactGroupsByUserQueryVariables> & ({ variables: ImpactGroupsByUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ImpactGroupsByUserQuery, ImpactGroupsByUserQueryVariables>(ImpactGroupsByUserDocument, options);
      }
export function useImpactGroupsByUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ImpactGroupsByUserQuery, ImpactGroupsByUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ImpactGroupsByUserQuery, ImpactGroupsByUserQueryVariables>(ImpactGroupsByUserDocument, options);
        }
// @ts-ignore
export function useImpactGroupsByUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ImpactGroupsByUserQuery, ImpactGroupsByUserQueryVariables>): Apollo.UseSuspenseQueryResult<ImpactGroupsByUserQuery, ImpactGroupsByUserQueryVariables>;
export function useImpactGroupsByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImpactGroupsByUserQuery, ImpactGroupsByUserQueryVariables>): Apollo.UseSuspenseQueryResult<ImpactGroupsByUserQuery | undefined, ImpactGroupsByUserQueryVariables>;
export function useImpactGroupsByUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ImpactGroupsByUserQuery, ImpactGroupsByUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ImpactGroupsByUserQuery, ImpactGroupsByUserQueryVariables>(ImpactGroupsByUserDocument, options);
        }
export type ImpactGroupsByUserQueryHookResult = ReturnType<typeof useImpactGroupsByUserQuery>;
export type ImpactGroupsByUserLazyQueryHookResult = ReturnType<typeof useImpactGroupsByUserLazyQuery>;
export type ImpactGroupsByUserSuspenseQueryHookResult = ReturnType<typeof useImpactGroupsByUserSuspenseQuery>;
export type ImpactGroupsByUserQueryResult = Apollo.QueryResult<ImpactGroupsByUserQuery, ImpactGroupsByUserQueryVariables>;